// Uclean-Admin-Dashboard/src/mocks/promo/_shared/base.js
// Single source of the promotion-engine URL prefix.
// Matches docs/admin-handover.md §2.1 platform-admin surface.
// REACT_APP_API_URL already includes the /api/v1 segment (consistent with the
// rest of this SPA's service modules), so we append only /promotion-engine/*.
export const BASE = `${process.env.REACT_APP_API_URL}/promotion-engine`;
